export default __webpack_public_path__ + "static/Oil-Tank-Removal-755699429461250f55df406c7356fc34.jpg";